import "typeface-roboto";
import "./index.css";

import { MuiThemeProvider } from "@material-ui/core/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import vi from "date-fns/locale/vi";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { renderRoutes } from "react-router-config";
import { BrowserRouter } from "react-router-dom";

import store from "./redux";
import router from "./routes";
import theme from "./theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
      gcTime: 0,
      retry: false,
    },
  },
});

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={vi}>
            <MuiThemeProvider theme={theme}>
              <BrowserRouter>
                <SnackbarProvider
                  maxSnack={3}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                  {renderRoutes(router)}
                </SnackbarProvider>
              </BrowserRouter>
            </MuiThemeProvider>
          </LocalizationProvider>
        </QueryClientProvider>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.querySelector("#root"));
